import { render, staticRenderFns } from "./RelationPointPanel.vue?vue&type=template&id=491ed345&scoped=true"
import script from "./RelationPointPanel.vue?vue&type=script&lang=js"
export * from "./RelationPointPanel.vue?vue&type=script&lang=js"
import style0 from "./RelationPointPanel.vue?vue&type=style&index=0&id=491ed345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ed345",
  null
  
)

export default component.exports